/**
 * App specific api
 */


import { Context, ConfigSchema, User, OpenIDAuthenticate } from "./types/config";

import { createApi, FetchArgs } from '@reduxjs/toolkit/query/react'
import { baseApiURL, baseQuery } from "./default";

// Define a service using a base URL and expected endpoints
export const AppAPI = createApi({
  reducerPath:'apiApp',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getContext: builder.query<Context, void>({
      query: () => `api/context`,
    }),
    getUser: builder.query<User, void>({
      query: () => `api/user`,
    }),
    getConfig: builder.query<ConfigSchema, void>({
      query: () => `config.json`,
    }),
    getOpenIdAuthenticate: builder.query<OpenIDAuthenticate, void>({
      query: () => `oidc/authenticate/?ajax=true`,
    }),
  }),
});

export const getLogoutURL = () => {
  return baseApiURL + '/oidc/logout/';
}

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const { useGetContextQuery, useGetConfigQuery, useGetUserQuery, useLazyGetUserQuery, useGetOpenIdAuthenticateQuery , } = AppAPI;
